import React, { useState } from 'react'
import { ArrowUpOutlined } from '@ant-design/icons'

const ScrollButton = () => {
  const [visible, setVisible] = useState(false)

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop
    if (scrolled > 300) {
      setVisible(true)
    } else if (scrolled <= 300) {
      setVisible(false)
    }
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
      /* you can also use 'auto' behaviour
         in place of 'smooth' */
    })
  }

  window.addEventListener('scroll', toggleVisible)

  return (
    <div className="scroll-to-top-button" style={{ display: visible ? 'inline' : 'none' }}>
      <ArrowUpOutlined onClick={scrollToTop} style={{ padding: 10, color: '#080' }} />
    </div>
  )
}

export default ScrollButton
